/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import AssetPreview from 'shared/ui/components/uploader/AssetPreview.vue';

const __vue_script__ = {
    name: 'AssetItemDetails',

    components: { AssetPreview },

    props: {
        params: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            asset: {},
            details: {},
            modelId: null
        };
    },

    async created() {
        try {
            const params = this.$router.getRouteParams();
            this.modelId = params.modelId;

            this.asset = await this.$services.documents.getDocById(this.params.event._id, this.modelId);
            const [details] = Object.values(this.asset.fp_attachments_s3 || {}) || [{}];
            this.details = details || {};

        } catch (error) {
            console.error('[AssetItemDetails] Could not load model', error);
        }
    },

    methods: {
        /**
         * Downloads the asset
         */
        download() {
            const eid = this.params.event._id;
            const [fileName] = Object.keys(this.asset.fp_attachments_s3 || {});
            const downloadUrl = this.$utils.assets.getEventAttachmentPath(eid, fileName, this.asset._id);
            this.$utils.browser.downloadFromUrl(downloadUrl);
        },

        /**
         * Show modal to confirm deletion.
         */
        promptDelete() {
            this.$modal.show('dialog', {
                text: this.$tc('asset_library.list.messages.prompt_deletes', 1),
                buttons: [
                    {
                        title: this.$t('general.cancel'),
                        default: true,
                        class: 'btn'
                    },
                    {
                        title: this.$t('general.confirm'),
                        handler: async () => {
                            this.deleteAsset();
                            this.$modal.hide('dialog');
                        },
                        class: 'btn btn-danger'
                    }
                ]
            });
        },

        /**
         * Deletes this asset
         */
        async deleteAsset() {
            try {
                // @ts-ignore
                await this.$services.documents.deleteDocs(this.params.event._id, this.params.event.node, this.$services.documents.PRINTABLE_ASSET_TYPE, [this.asset.fp_ext_id]);
                this.$router.goToParent();
            } catch (error) {
                console.error('[AssetItemDetails] An error occurred', error.message || error);

                this.$notify({
                    group: 'flashes',
                    title: this.$i18n.t('general.error_occurred').toString(),
                    text: this.$i18n.t('general.try_later').toString(),
                    type: 'error',
                    duration: 5000
                });
            }
        }
    }

};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.asset)?_c('div',{staticClass:"asset-item-details"},[_c('header',[_c('div',{staticClass:"page-actions"},[(!_vm.details.upload_error && _vm.details.length)?_c('button',{staticClass:"btn btn-icon single download",on:{"click":function($event){return _vm.download()}}},[_c('i',{staticClass:"ic-download"})]):_vm._e(),(!_vm.details.eventName)?_c('button',{staticClass:"btn btn-danger btn-icon single delete",on:{"click":function($event){return _vm.promptDelete()}}},[_c('i',{staticClass:"ic-trash"})]):_vm._e()]),_c('h1',[_vm._v(_vm._s(_vm.asset.title || _vm.asset.file_name))])]),_c('section',{staticClass:"contents panels panels-a"},[_c('div',{staticClass:"panel"},[_c('asset-preview',{attrs:{"asset":_vm.asset,"event":_vm.params.event}})],1),_c('div',{staticClass:"panel"},[_c('dl',{staticClass:"small"},[_c('dt',[_vm._v(_vm._s(_vm.$t('asset_library.details.file_name')))]),_c('dd',[_vm._v(_vm._s(_vm.asset.file_name))]),_c('dt',[_vm._v(_vm._s(_vm.$t('asset_library.details.original_content_type')))]),_c('dd',[_vm._v(_vm._s(_vm.$utils.attachments.getHumanReadableMime(_vm.asset)))]),_c('dt',[_vm._v(_vm._s(_vm.$t('asset_library.details.timestamp')))]),_c('dd',[_vm._v(_vm._s(_vm.$utils.time.tsToLongDateTimeFormat(_vm.asset.timestamp || _vm.asset.fp_created_timestamp)))]),_c('dt',[_vm._v(_vm._s(_vm.$t('asset_library.details.file_size')))]),_c('dd',[_vm._v(_vm._s(_vm.$utils.attachments.getSize(_vm.asset, _vm.$i18n)))])])])])]):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "AssetItemDetails.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__